exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".confirmationDialog_dialogHeader__3Axs1{background:#fcf1e2}.confirmationDialog_warningIcon__1WYSq{color:#fb8c00}", ""]);

// exports
exports.locals = {
	"dialogHeader": "confirmationDialog_dialogHeader__3Axs1",
	"warningIcon": "confirmationDialog_warningIcon__1WYSq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Dialog/confirmationDialog.less
// module id = 1909
// module chunks = 8